<template>
  <el-menu mode="vertical" unique-opened :default-active="defaultActiveIndex">
    <div class="sidebar-wrapper">
      <template v-for="item in displayMenu">
        <div v-if="!item.hidden" :key="item.path">

          <router-link
            :to="item.path"
            v-if="item.noDropdown && (item.children == undefined || item.children == null || item.children.length==0)"
            :key="item.path">
            <el-menu-item :index="item.name" class="leftMenuItem">
              <span>{{item.name}}</span>
            </el-menu-item>
          </router-link>

          <el-submenu v-else :index="item.name" :key="item.name" class="secondMenu">
            <template slot="title">
              <span class="leftMenuItem" >{{item.name}}</span>
            </template>
            <el-menu-item-group v-for="childrenItem in item.children" :key="childrenItem.path">
              <router-link :to="childrenItem.path">
                <el-menu-item
                  :index="childrenItem.name"
                  class="leftMenuItem leftMenuItem_second">
                   {{childrenItem.name}}
                  </el-menu-item>
              </router-link>
            </el-menu-item-group>
          </el-submenu>
          
        </div>
      </template>
    </div>
  </el-menu>

</template>
<script>
import { mapGetters } from "vuex";
import { asyncRouterMap } from "@/router";
import { getToken } from "@/utils/auth";
export default {
  name: "sidebar",
  data() {
    return {
      filteredRouterMap: [],
      displayMenu: [],
      currentPath: "",
      defaultActiveIndex:'', 
    };
  },
  watch: {
    //监视路由变化刷新左侧菜单
    $route: function(to, from) {
      
      let authorizationKeyArray = this.$userContext.getAuthorizationKeyArray();
      this.filteredRouterMap = this.filterAsyncRouter(asyncRouterMap, authorizationKeyArray);

      let toPathArray = to.path.split("/");
      let path = "/" + toPathArray[1];

      //把路由中的第二层做为菜单显示出来
      this.filteredRouterMap.forEach(item => 
      {
          if (item.path === path) 
          {
            this.displayMenu = item.children;
          }
      });
     
    }
  },
  created() {
    let authorizationKeyArray = this.$userContext.getAuthorizationKeyArray();
    this.filteredRouterMap = this.filterAsyncRouter(asyncRouterMap, authorizationKeyArray);

    let toPath = this.$router.history.current.fullPath.split("/");
    let path = "/" + toPath[1];
    
    //把路由中的第二层做为菜单显示出来
     this.filteredRouterMap.forEach(item => 
     {
        if (item.path === path) 
        {
          this.displayMenu = item.children;
        }
      });
  },
  methods: {
    filterAsyncRouter(asyncRouterMap, authorizationKeyArray) 
    {
      let userInfo = this.$userContext.getUser();
      if(userInfo.domainAdmin) 
        return asyncRouterMap;

      let accessedRouters = asyncRouterMap.filter(routeItem => 
      {
        let hasPermission = false;
        if (routeItem.role && routeItem.role.length>0) 
        {
          hasPermission = authorizationKeyArray.some(
            authorizationKey => routeItem.role.indexOf(authorizationKey) >= 0
            );
        } 
        else 
        {
          hasPermission = true;
        }

        if (hasPermission) 
        {
          if (routeItem.children && routeItem.children.length) 
          {
            routeItem.children = this.filterAsyncRouter(routeItem.children, authorizationKeyArray);
          }
          return true;
        }
        return false;
      });

      return accessedRouters;
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.el-menu {
  border: none;
  background-color: transparent;
}
.sidebarContainer {
  margin-top: 30px;
  
  .leftMenuItem {
    font-size: 15px;
    color: #000;
    height: 36px;
    line-height: 34px;
    padding-left: 50px !important;
    margin-top: 20px;
    margin-bottom: 5px;
  }
  .router-link-exact-active.router-link-active .leftMenuItem {
    color: #fff;
    text-decoration: none;
    font-size: 15px;
    background-image: url("../../assets/leftMenuItem_active.jpg");
    background-position-x: 1px;
  }
  .leftMenuItem.el-menu-item:hover {
    color: #ffa64d;
    background-color: transparent;
  }
  .secondMenu{
     margin-top: 20px;
    margin-bottom: 5px;
  }
  .leftMenuItem_second {
    padding-left: 70px !important;
    margin-top: 0px;
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/sidebar.vue